module.exports = __webpack_public_path__ + "static/media/arrow_canvas.2beb5062.svg";